export function buildUrl(
  baseUrl: string,
  path: string,
  query?: Record<string, string | number | boolean | undefined | null>,
): string {
  let base =
    baseUrl ||
    (typeof window !== 'undefined' ? window.location.origin : 'http://localhost')
  if (!base.startsWith('http://') && !base.startsWith('https://')) {
    const origin =
      typeof window !== 'undefined' ? window.location.origin : 'http://localhost'
    base = new URL(base, origin).toString()
  }
  const cleanBase = base.endsWith('/') ? base : `${base}/`
  const cleanPath = path.startsWith('/') ? path.slice(1) : path
  const url = new URL(cleanPath, cleanBase)

  if (query) {
    for (const [key, value] of Object.entries(query)) {
      if (value != null) {
        url.searchParams.set(key, String(value))
      }
    }
  }

  return url.toString()
}
